import {useEffect, useState} from 'react';
import {DefaultOptionType} from "antd/es/select";
import {Channel, Factor} from "../../../../../api/types";
import {useEngine} from "../../../../../hooks/useEngine";

export default function useFilterOptions() {
  const [channelsOptions, setChannelsOptions] = useState<DefaultOptionType[]>([]);
  const [factorsOptions, setFactorsOptions] = useState<DefaultOptionType[]>([]);
  const {engine} = useEngine();

  useEffect(() => {
    if (engine) {
      if (engine.channels && engine.channels.length > 0) {
        setChannelsOptions(engine.channels.map((channel: Channel) => {
          return {
            value: channel.id,
            label: channel.name,
          };
        }));
      }

      if (engine.factors && engine.factors.length > 0) {
        setFactorsOptions(engine.factors
          .filter((factor: Factor) => !factor.isChannel)
          .map((factor: Factor) => {
            return {
              value: factor.id,
              label: factor.name,
            };
          }));
      }
    }
  }, [engine]);

  return ({
    channelsOptions,
    factorsOptions,
  });
}
